import { render, staticRenderFns } from "./bookInfo.vue?vue&type=template&id=0caa5765&scoped=true"
import script from "./bookInfo.vue?vue&type=script&lang=js"
export * from "./bookInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caa5765",
  null
  
)

export default component.exports